import {BaseService} from './Core/BaseService';
import {BaseSearchableService} from "./Core/BaseSearchableService";

class ProgramService extends BaseSearchableService {
    get Url() { return super.Url + "/programs"; }
    get ModelName() { return "Programs"; }
    get PrimaryKeyProperty() { return "programId"; }

    // Distinguish top-level programs from subprograms in autocomplete results, and
    // name the parent so sibling subprograms sharing a name stay distinguishable.
    // Programs only nest one level, so parentProgramId being set is sufficient.
    GetSubtitle(model) {
        if (!model) {
            return null;
        }
        if (!model.parentProgramId) {
            return "Program";
        }
        const parentName = this.CachedTitleById(model.parentProgramId);
        return parentName ? `Sub-program of ${parentName}` : "Sub-program";
    }

    // Parent programs aren't on the search payload, but GetSubtitle has to name them
    // synchronously at render, so prime them into the id cache first. FindById
    // coalesces the ids into a single batched request. Uses super.FindById so
    // priming a parent can't re-enter this method.
    _primeParentPrograms(models) {
        const parentIds = [...new Set(
            models.map((model) => model?.parentProgramId).filter(Boolean)
        )];

        // allSettled: one unresolvable parent must not fail the whole lookup.
        return Promise.allSettled(parentIds.map((id) => super.FindById(id)));
    }

    GetPrograms() {
        return this.SendRequest(
            BaseService.GET,
            null,
            null, 
            "",
            true
        );
    }

    async Search(name, additionalParameters = null) {
        let request = {
            name: name,
            ...additionalParameters
        };

        const response = await this.SendRequest(BaseService.GET, request);

        const result = response?.result ?? [];
        await this._primeParentPrograms(Array.isArray(result) ? result : [result]);

        return response;
    }

    // A pre-selected value hydrates through FindById rather than Search, so prime
    // its parent here too or the subtext under a closed picker loses the parent name.
    async FindById(id, useCache = true) {
        const response = await super.FindById(id, useCache);

        await this._primeParentPrograms([response?.result].filter(Boolean));

        return response;
    }

    GetChildrenPrograms(parentId) {
        let request = {parentId: parentId};
        return this.SendRequest(BaseService.GET, request);
    }

    GetProgram(programId) {
        return this.SendRequest(BaseService.GET, programId);
    }

    UpdateProgram(program) {
        return this.SendRequest(BaseService.PUT, program);
    }

    CreateProgram(program) {
        return this.SendRequest(BaseService.POST, program);
    }

    DeleteProgram(programId) {
        return this.SendRequest(BaseService.DELETE, programId);
    }
}

export const service = new ProgramService();

